/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TransferirTitularidadeAliases {
  AUTOCOMPLETE_ALTERAR_TITULAR = 'autocomplete-alterar-titular',
  CARD_0 = 'card-0',
  FETCH_ALTERAR_TITULAR = 'fetch-alterar-titular',
  FETCH_BENEFICIARIOS = 'fetch-beneficiarios',
  FIELD_ALTERAR_TITULAR = 'field-alterar-titular',
  FORM_ALTERAR_TITULAR = 'form-alterar-titular',
  MAPPER_ALTERAR_TITULAR = 'mapper-alterar-titular',
  PANEL_0 = 'panel-0',
  PANEL_ALTERAR_TITULAR = 'panel-alterar-titular',
  TEXT_ALTERAR_TITULAR = 'text-alterar-titular',
}
export { TransferirTitularidadeAliases };
